import { render, staticRenderFns } from "./companies.vue?vue&type=template&id=05f73e51&"
import script from "./companies.vue?vue&type=script&lang=js&"
export * from "./companies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports